import React, { type PropsWithChildren } from 'react';
import AuthorizationLayout from '../components/AuthorizationLayout';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import '../styles.scss';
import { useForgotPasswordMutation } from '../../infrastructure/api/auth.api';

const ForgotPassword = (props: PropsWithChildren) => {
  const { t } = useTranslation();
  const [forgotPassword] = useForgotPasswordMutation();

  const submitForgotPassword = async (data) => {
    const list = await forgotPassword().unwrap();
    const users = Array.isArray(list) ? list : [];
    users.find((user) => user.email === data.email);
  };

  return (
    <AuthorizationLayout {...props}>
      <div className={'border br-16 p-16'}>
        <div className="block-title fs-3">{t('forgot_password.title')}</div>
        <Formik<any>
          initialValues={{ email: '' }}
          validate={(values) => {
            const errors: any = {};
            if (!values.email) {
              errors.email = t('form.required');
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
              errors.email = t('form.invalid_email');
            }
            return errors;
          }}
          onSubmit={submitForgotPassword}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
              <div className="row mb-4">
                <div className="col-12">
                  <label htmlFor="email">{t('sign_in.email')}</label>
                  <input
                    className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                    type="email"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                  />
                </div>
              </div>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {t('forgot_password.send')}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </AuthorizationLayout>
  );
};

export default ForgotPassword;
